module.exports = __webpack_public_path__ + "static/media/display-suite-05.60bc89ec.jpg";